// Generated by Melange

import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgSettingsBrand from "../../components/organisms/Settings/OrgSettingsBrand.js";
import * as Buhta_cabinet__OrgSettingsChief from "../../components/organisms/Settings/OrgSettingsChief.js";
import * as Buhta_cabinet__OrgSettingsGeneral from "../../components/organisms/Settings/OrgSettingsGeneral.js";
import * as Buhta_cabinet__OrgSettingsTaxes from "../../components/organisms/Settings/OrgSettingsTaxes.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as JsxRuntime from "react/jsx-runtime";

function OrgSettingsPage(Props) {
  let org = Props.org;
  let tab = Props.tab;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
    title: "Общая информация"
  });
  let tmp;
  switch (tab) {
    case /* General */ 0 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__OrgSettingsGeneral.make, {
        org: org
      });
      break;
    case /* Brand */ 1 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__OrgSettingsBrand.make, {
        org: org
      });
      break;
    case /* Chief */ 2 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__OrgSettingsChief.make, {});
      break;
    case /* Tax */ 3 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__OrgSettingsTaxes.make, {});
      break;
  }
  return JsxRuntime.jsxs(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_cabinet__Link.make, {
            route: contextRoute({
              TAG: /* Settings */ 8,
              _0: /* General */ 0
            }),
            className: Cn.fromList({
              hd: "py-2.5 grow lg:grow-0",
              tl: {
                hd: Cn.on("border-b border-links", tab === /* General */ 0),
                tl: /* [] */ 0
              }
            }),
            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: Cn.fromList({
                hd: "text-center",
                tl: {
                  hd: tab === /* General */ 0 ? "text-links" : "text-gray-medium",
                  tl: /* [] */ 0
                }
              }),
              children: "Предприятие"
            })
          }),
          JsxRuntime.jsx(Buhta_cabinet__Link.make, {
            route: contextRoute({
              TAG: /* Settings */ 8,
              _0: /* Brand */ 1
            }),
            className: Cn.fromList({
              hd: "py-2.5 grow lg:grow-0",
              tl: {
                hd: Cn.on("border-b border-links", tab === /* Brand */ 1),
                tl: /* [] */ 0
              }
            }),
            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: Cn.fromList({
                hd: "text-center",
                tl: {
                  hd: tab === /* Brand */ 1 ? "text-links" : "text-gray-medium",
                  tl: /* [] */ 0
                }
              }),
              children: "Бренд"
            })
          }),
          JsxRuntime.jsx(Buhta_cabinet__Link.make, {
            route: contextRoute({
              TAG: /* Settings */ 8,
              _0: /* Chief */ 2
            }),
            className: Cn.fromList({
              hd: "py-2.5 grow lg:grow-0",
              tl: {
                hd: Cn.on("border-b border-links", tab === /* Chief */ 2),
                tl: /* [] */ 0
              }
            }),
            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: Cn.fromList({
                hd: "text-center",
                tl: {
                  hd: tab === /* Chief */ 2 ? "text-links" : "text-gray-medium",
                  tl: /* [] */ 0
                }
              }),
              children: "Руководитель"
            })
          }),
          JsxRuntime.jsx(Buhta_cabinet__Link.make, {
            route: contextRoute({
              TAG: /* Settings */ 8,
              _0: /* Tax */ 3
            }),
            className: Cn.fromList({
              hd: "py-2.5 grow lg:grow-0",
              tl: {
                hd: Cn.on("border-b border-links", tab === /* Tax */ 3),
                tl: /* [] */ 0
              }
            }),
            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: Cn.fromList({
                hd: "text-center",
                tl: {
                  hd: tab === /* Tax */ 3 ? "text-links" : "text-gray-medium",
                  tl: /* [] */ 0
                }
              }),
              children: "Налоги"
            })
          })
        ],
        className: "bg-white px-2 lg:px-6 border-b border-gray-main w-full flex justify-between lg:justify-start lg:gap-4"
      }),
      tmp
    ],
    className: "flex-col bg-gray-pale"
  });
}

const make = OrgSettingsPage;

export {
  make,
}
/* Buhta_cabinet__DashboardContentTemplate Not a pure module */
